import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { isDistro, isMethodPage } = {}) => ({
    table: {
      borderSpacing: '0 16px',
      borderCollapse: 'separate',
      ...(isMethodPage && {
        '& .MuiTableCell-root': {
          padding: '5px 22px',
        },
      }),
      '& thead tr th': {
        fontWeight: 600,
        '&:nth-child(1)': {
          paddingRight: 0,
          paddingLeft: theme.spacing(3),
          width: pickIf(isMethodPage, '12%', '15%'),
        },
        '&:nth-child(2)': {
          paddingRight: 0,
          width: pickIf(isMethodPage, '5%', '10%'),
        },
        '&:nth-child(3)': {
          width: pickIf(isMethodPage, '11%', '13%'),
        },
        '&:nth-child(4)': {
          width: pickIf(isMethodPage, '5%', '7%'),
        },
        '&:nth-child(5)': {
          textAlign: 'right',
          width: pickIf(isMethodPage, '8%', '9%'),
        },
        '&:nth-child(6)': {
          textAlign: 'right',
          width: pickIf(isMethodPage, '4%', '6%'),
        },
        '&:nth-child(7)': {
          textAlign: 'right',
          width: pickIf(isDistro, '5%', '9%'),
        },
        '&:nth-child(8)': {
          textAlign: 'right',
          width: pickIf(isDistro, '6%', '7%'),
        },
        '&:nth-child(9)': {
          textAlign: 'right',
          width: '6%',
        },
        '&:nth-child(10)': {
          width: pickIf(isDistro, '5%', '17%'),
        },
        ...(isDistro && {
          '&:nth-child(11)': {
            width: '18%',
          },
        }),
      },
    },
    row: {
      boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
      borderRadius: 10,
      '& th, & td': {
        fontSize: 14,
        paddingBottom: 5,
        paddingTop: 5,
        lineHeight: '20px',
      },
      '& td': {
        '&:nth-child(1)': {
          paddingLeft: theme.spacing(3),
          paddingRight: 0,
        },
        '&:nth-child(2)': {
          paddingRight: 0,
        },
        '&:nth-child(5)': {
          textAlign: 'right',
        },
        '&:nth-child(6)': {
          paddingLeft: 0,
          paddingRight: 12,
          textAlign: 'right',
        },
        '&:nth-child(7)': {
          textAlign: 'right',
        },
        '&:nth-child(8)': {
          textAlign: 'right',
        },
        '&:nth-child(9)': {
          textAlign: 'right',
        },
        ...(isDistro && {
          '&:nth-child(10)': {
            textAlign: 'right',
          },
        }),
      },
    },
  }),
);
